export const maxStringLength = 33;

export const error_message = {
  csv: {
    no_data: "CSVデータがありません。",
    parse_error: "CSVファイルの解析中にエラーが発生しました。",
    loading: "ファイルの読み込み中にエラーが発生しました。",
    no_file_selected: "ファイルが選択されていません",
    incorrect_headers: "CSVファイルのヘッダーが正しくありません。",
    null_fields:
      "入力ファイルの一部にエラーがあります。内容を確認してください。",
    timeout:
      "CSVの処理に時間がかかりすぎています。再度アップロードしてください。",
    timeout_users_created:
      "一部のユーザーはすでに作成されている可能性があります。",
    polling_error: "CSVのステータスを取得中にエラーが発生しました。",
    failed_download:
      "CSVのダウンロードに失敗しました。しばらくしてから再度お試しください。",
  },
  image: {
    upload: "イメージのアップロードにエラーが発生しました。",
    not_selected: "ファイルが選択されていません",
    no_user: "ユーザデータがありません。アップロードできません。",
    delete: "failed to delete image",
  },
  notification: {
    is_null: "notification is null.",
    start_data: "開始日が終了日より後になることはできません。",
    not_found: (id) => `お知らせ: ${id}の配信が停止されています。`,
    no_data: "お知らせはありません。",
  },
  tenant: {
    date_not_defined: "開始、または終了日日は空であってはいけません。",
    bad_input: "開始日と終了日は正しく設定してください。",
    blank_unit_price: "単価は空であってはいけません。",
    bad_unit_price: "単価は数字のみ使用できます。",
    exists: (name) => `テナントID: ${name}がすでに存在しています。`,
    unknown_app: (id) => `不明なアプリ - ${id}`,
    no_contract: "契約データがありません。",
    no_active_contract: "契約中ライセンスがありません。",
    no_data: "企業情報を読み取れませんでした",
    realm_not_found: (selectedRealm) =>
      `テナントID<${selectedRealm}>が存在していません。`,
    no_groups_found: "利用可能なグループはありません",
  },
  departments: {
    load_failed: "failed to load departments",
    parent_failed: "failed to update parent:",
    no_data: "部署選択がありません",
    not_found: (id) => `department with id ${id} not found.`,
    get: "部署の情報を取得できませんでした。",
    no_departments: "部署はありません。",
  },
  admin_user: {
    not_defined: "admin user data is not defined.",
  },
  contact: {
    data_load: "Error fetching contact data",
    not_found: (id) => `電話帳: ${id}のデータが見つかりませんでした`,
    card_id_not_found: "Blob ID not found for the selected image.",
  },
  user: {
    not_selected: "電話帳が選択されていません。",
    select_single: "一つのユーザを選んでください。",
    not_found: "ユーザのデータが見つかりませんでした",
    not_found_id: (id) => `ユーザー: ${id}のデータが見つかりませんでした`,
    delete: "Error deleting user:",
    role: "有効なロールを選択してください。",
    no_apps: "利用可能アプリはありません",
    no_groups: "利用可能グループはありません",
    no_app_registered: "アプリはありません",
    not_loaded: "表示する電話帳情報はありません",
    no_data: "表示する電話帳情報はありません",
    not_found_in_database: "ユーザがデータベースに存在していません。",
    main_delete: "全部のユーザを削除することはできません。",
    single_user_upload_failed: "1件の一括登録が処理に失敗しました。",
    no_external_data_download: "ダウンロードする社外電話帳情報がありません。",
    no_internal_data_download: "ダウンロードする社内電話帳情報がありません。",
    excessive_data_delete:
      "101件以上削除をする場合、CSVアップロードで削除してください。",
  },
  keycloak: {
    token_refresh: "failed to refresh token",
    token_expired: "token has expired",
  },
  workjoy: {
    no_stamp_data: "スタンプが登録されていません。",
  },
  yobely: {
    search: "検索に失敗しました。",
    not_found: "グループはありません。",
    license_error: "YOBELYは未契約です。",
  },
  password: {
    no_match: "パスワードが一致しません。",
    blank_field: "未入力のフィールドがあります。",
    must_init: "パスワードを初期化してください",
    bad_policy: "パスワードがポリシーに一致しません。",
  },
  role: {
    not_found: "権限設定できる半角数字以外が入力されています。",
  },
  generic: {
    unknown: "An unknown error has occurred.",
    bad_field: "1つ以上のフィールドに無効な入力があります",
    no_tenant: "テナントが見つかれませんでした。",
    session_expired: "セッション期限が経ちました。",
    no_connection: "管理システムに接続できません。",
    wait_retry: "しばらくお待ちいただき再度ログインをお願いいたします。",
    admin_route: "このページにアクセスする権利はありません。",
    app_not_available: (appName) => `${appName}は現在ご利用いただけません。`,
    no_access: "このページにアクセスすることができません。",
    no_func_bound: "nothing bound.",
    common: "エラーが発生しました。",
    string_parse: "error parsing the error string",
    access_denied: "401 - Access Denied",
    not_found: "404 - Page Not Found",
    page_not_found: "お探しのページは存在しません。",
    enter_tenant: "テナントIDを入力してくだい。",
  },
  broadcast_group: {
    not_found: "一斉発信グループはありません。",
    no_data: "一斉発信グループ情報を読み取れませんでした",
    not_found_id: (id) =>
      `一斉発信グループ: ${id}のデータが見つかりませんでした`,
    delete: "Error deleting group:",
  },
};

export const UserFieldErrorMessages = {
  nameError: "有効な氏名を入力してください。",
  keycloakNameError: "氏名（姓・名）に『-_@.』以外の記号は使用できません。",
  nameKanaError: "有効なかな文字（ひらがな・カタカナ）を入力してください。",
  nameHiraganaError: "有効なかな文字（ひらがな・カタカナ）を入力してください。",
  nameFuriganaError: "有効なフリガナ文字を入力してください。",
  telephoneNumberError:
    "有効な電話番号形式(10桁または、11桁の数字のみ)で入力してください。",
  telephoneNumberErrorNoLimit: "電話番号は数字のみで入力してください。",
  faxNumberError:
    "有効なFAX番号形式(10桁または、11桁の数字のみ)で入力してください。",
  loginIdError:
    "ユーザーIDは、3文字以上64文字以内で、半角英数字と『-_@.』を使用できます。",
  loginIdLengthError: "ユーザーIDは3文字以上64文字以内で入力してください。",
  loginIdExistsError: "ユーザーIDがすでに存在しています。",
  emailExistsError: "メールアドレスがすでに存在しています。",
  employeeNumberError: "半角英数字のみ入力してください。",
  positionError: "有効な役割を入力してください。",
  lengthError: `${maxStringLength}字以内で入力してください。`,
  roleError: "有効なロールを選択してください。",
  passwordError: "パスワードがポリシーに一致しません。",
  passwordNoMatchError: "変更後と変更後（再入力）のパスワードが一致しません。",
  noPersonalOrCompanyTel:
    "個人電話番号または会社電話番号のいずれかを入力してください。",
  displayOrderError: "部署コードは半角英数字のみ利用可能です。",
};

export const TenantFieldErrorMessages = {
  nameError: "有効な名前を入力してください。",
  nameKanaError: "有効なかな文字を入力してください。",
  nameHiraganaError: "有効なかな文字（ひらがな・カタカナ）を入力してください。",
  nameFuriganaError: "有効なフリガナ文字を入力してください。",
  telephoneNumberError: "有効な電話番号形式(10,11数字のみ)で入力してください。",
  faxNumberError:
    "有効なFAX番号形式(10桁または、11桁の数字のみ)で入力してください。",
  loginIdError: "ログインが保存後変更できません。",
  postcodeError: "有効な郵便番号形式(1231234)で入力してください。",
  positionError: "有効な役割を入力してください。",
  lengthError: `${maxStringLength}字以内で入力してください。`,
  codeError:
    "値は大文字の英字 (A-Z)、数字 (0-9)、アンダースコア (_) のみを含み、5文字以上64文字以内である必要があります。",
  storeIdError: "店舗IDは数字のみ使用できます。",
  subDirectoryError: "６以上の英文字と数字のみ使用できます。",
};

export const ContractFieldErrorMessages = {
  dateError: "開始日が終了日より後になることはできません。",
};

export const translatedDuplicateMessages = {
  "full name": "氏名",
  email: "メールアドレス",
  "personal tel": "個人電話番号",
};
